import { reduceProductsResponse } from 'pricing-pages-lib/reducers/Products';
import Raven from 'raven-js';
import { FetchProductsRequestTypes } from '../actions/ProductsActions';
const initialState = {
  productMap: {},
  productVersions: {},
  skuMap: {},
  parcelNameToProductId: {},
  quantityPackApiNameToProductId: {}
};

const AbstractedProducts = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchProductsRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;

        if (!Array.isArray(data)) {
          Raven.captureException(new Error('Invalid response from Product Abstraction endpoint'), {
            extra: {
              data
            }
          });
        }

        return reduceProductsResponse(data);
      }

    default:
      return state;
  }
};

export default AbstractedProducts;